import React from 'react'
import PropTypes from 'prop-types'

import { MetaData } from '../../components/common/meta'
import Layout from '../../components/Layout'
import Listing from '../../components/Listing'
import Pagination from '../../components/Pagination'
import RecentPosts from '../../components/RecentPosts'

function Tag({ data, location, pageContext }) {
  const posts = data.allGhostPost.nodes
  const recentPosts = data.allGhostPostRecent.nodes
  const { prevPagePath, nextPagePath, name } = pageContext

  return (
    <>
      <MetaData data={data} location={location} title={name} type="series" />
      <Layout sidebar>
        <div className="container">
          <div className="flex justify-center">
            <div id="left-area" className="max-w-3xl flex-1">
              <article className="et_pb_post post type-post status-publish format-standard hentry">
                <h1 className="main_title">Articles from {name}</h1>
              </article>
              <Listing posts={posts} />
              <Pagination prev={prevPagePath} next={nextPagePath} />
            </div>
            <div id="sidebar">
              <RecentPosts posts={recentPosts} />
            </div>
          </div>
        </div>
      </Layout>
    </>
  )
}

Tag.propTypes = {
  data: PropTypes.shape({
    allGhostPost: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      nodes: PropTypes.arrayOf(PropTypes.object),
    }),
    allGhostPostRecent: PropTypes.shape({
      // eslint-disable-next-line react/forbid-prop-types
      nodes: PropTypes.arrayOf(PropTypes.object),
    }),
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  pageContext: PropTypes.shape({
    name: PropTypes.string.isRequired,
    prevPagePath: PropTypes.string,
    nextPagePath: PropTypes.string,
  }).isRequired,
}

export default Tag
